<router-outlet />
<app-support-chatbot />

<!-- A newer deploy is live but this tab hasn't navigated (navigation
     auto-reloads above): give a parked tab a visible way onto the new build.
     Mounting the kit component is what starts the version poll. -->
<ng-container *transloco="let t">
  <crwd-app-update [label]="t('app-update.available')" [actionLabel]="t('app-update.refresh')" />
</ng-container>
